.actions {
  display: flex;
  justify-content: flex-start;

  & > a {
    margin-right: 1em;
  }

  & > a:last-child {
    margin-right: 0;
  }
}
